import Vue from 'vue';
import { formatNum } from '@/util/number';
import { kmhToKnot } from '@/util/units';

Vue.filter('toKnot', (value) => {
  if (value === undefined) return '';
  return formatNum(kmhToKnot(value), 2);
});

Vue.filter('toKM', (value) => {
  if (value === undefined) return '';
  return formatNum((value / 1000), 2);
});

Vue.filter('toNM', (value) => {
  if (value === undefined) return '';
  return formatNum((value * 0.00053996), 2);
});
